import React, { useEffect } from 'react';
import './ProjectDetail.css'

import AOS from 'aos';
import 'aos/dist/aos.css';



const ProjectDetail = (props) => {

    useEffect(() => {
        AOS.init({ duration: 1000 })
    })

    const { id, projectName, projectDescription, website, source, tech1, tech2, tech3, tech4, img, tech5, tech6 } = props.project;

    return (

        <div data-aos="fade-right">
            <div className='row project-area' >
                <div className="col-md-6 project-img">
                    <img src={img} alt="" />
                </div>
                <div className="col-md-6">
                    <div className="project-description">
                        <div className="card text-center web-bg project-bdy">
                            <div className="card-header">
                                {id}
                            </div>
                            <div className="card-body des">
                                <h2 className="card-title"> {projectName} </h2>
                                <p className="card-text">
                                    {projectDescription}
                                </p>
                                <div className="build-item">
                                    <strong className="built"> {tech1} </strong>
                                    <strong className="built"> {tech2} </strong>
                                    <strong className="built"> {tech3} </strong>
                                    <strong className="built"> {tech4} </strong>
                                    <strong className="built"> {tech5} </strong>
                                    <strong className="built"> {tech6} </strong>
                                </div>

                            </div>
                            <div className="card-footer text-muted">
                                <div className="info-btn">
                                    <a href={website} target="_blank" className="project-info-btn">Website</a>
                                    <a href={source} target="_blank" className="project-info-btn">Source
                      Code</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectDetail;











// import React from 'react';
// import './ProjectDetail.css'

// import AOS from 'aos';
// import 'aos/dist/aos.css';



// const ProjectDetail = (props) => {

//     const { id, projectName, projectDescription, website, source, tech1 , tech2 , tech3 , tech4 , img , tech5 , tech6} = props.project;

//     return (

//         <div>
//             <div className='row project-area'>
//                 <div className="col-md-6 project-img">
//                     <img src={img} alt="" />
//                 </div>
//                 <div className="col-md-6">
//                     <div className="project-description">
//                         <div className="card text-center project-bdy">
//                             <div className="card-header">
//                                 {id}
//                             </div>
//                             <div className="card-body des">
//                                 <h2 className="card-title"> {projectName} </h2>
//                                 <p className="card-text">
//                                     {projectDescription}
//                                 </p>
//                                 <strong className="built"> {tech1} </strong>
//                                 <strong className="built"> {tech2} </strong>
//                                 <strong className="built"> {tech3} </strong>
//                                 <strong className="built"> {tech4} </strong>

//                             </div>
//                             <div className="card-footer text-muted">
//                                 <div className="info-btn">
//                                     <a href={website} target="_blank" className="project-info-btn">Website</a>
//                                     <a href={source} target="_blank" className="project-info-btn">Source
//                       Code</a>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ProjectDetail;